<template>
  <div class="action-bar">
    <div class="action-bar__text"><slot></slot></div>
    <div class="action-bar__keys" v-show="showPropertyKey">
      <div class="action-bar__key action-bar__key--available"></div><div class="action-bar__key-text">Available</div>
      <div class="action-bar__key action-bar__key--hold"></div><div class="action-bar__key-text">On Hold</div>
      <div class="action-bar__key action-bar__key--sold"></div><div class="action-bar__key-text">Sold</div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ 'show-property-key' ]
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.action-bar {

  background-color: $aqua;
  padding: 0 6rem;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;

  &__text {
    font-size: 2.8rem;
    line-height: 7rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  &__keys {
    display: flex;
    align-items: center;
  }

  &__key {
    border-radius: 2.5rem;
    height: 3rem;
    width: 3rem;
    margin: 0 1rem 0 3rem;

    &-text {
      font-size: 2rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    &--available {
      background-color: $dot-available;
    }

    &--hold {
      background-color: $dot-hold;
    }

    &--sold {
      background-color: $dot-sold;
    }
  }
}
</style>